import { SkuInfoType, SpuSaleInfoType } from "../../../types";

export function joinProperties(spuSaleInfos: SpuSaleInfoType[], currentSku: SkuInfoType): string[] {
  return spuSaleInfos.map((item) => currentSku?.properties[item.name]).filter(Boolean);
}
